export default __webpack_public_path__ + "static/media/detail_big_16_7.29ce1ca6.jpg";